var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialTwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.568 4 5 8.183v16.729h5.749v3.138h3.138l3.135-3.138h4.704L28 18.64V4H6.568zm2.09 2.09H25.91v11.503l-3.66 3.66H16.5l-3.135 3.134v-3.134H8.658V6.09zm5.75 10.458H16.5v-6.273h-2.091v6.273zm5.75 0h2.092v-6.273h-2.091v6.273z",
    fill: "#4884E8",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTwitch);
export default __webpack_public_path__ + "static/media/social-twitch.b53dbe84.svg";
export { ForwardRef as ReactComponent };